/**
 * @file コンポーネント：ノート DOM管理
 */

// ライブラリ読み込み
import React from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

// コンポーネント読み込み
import { ModalNoteDelete } from "~/src/components/projects/ModalNoteDelete";

// スタイル読み込み
import {
    StyledNote,
    StyledNoteBody,
    StyledNoteButton,
    StyledNoteButtonIcon,
    StyledNoteButtonText,
    StyledNoteNavigation,
    StyledNoteNavigationButtonlist,
    StyledNoteNavigationButtonlistItem,
    StyledNoteNavigationHistory,
    StyledNoteNavigationHistoryIcon,
    StyledNoteNavigationHistoryTime,
    StyledNoteNavigationText,
    StyledNoteToolbar,
    StyledNoteToolbarButton,
    StyledNoteToolbarItem,
    StyledNoteToolbarSelect,
    StyledNoteToolbarSelectOption,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <>
            {props.isLoading === false && (
                <StyledNote>
                    {/* ReactQuill ツールバー */}
                    <StyledNoteToolbar id="js-note-toolbar">
                        <StyledNoteToolbarItem className="ql-formats">
                            <StyledNoteToolbarSelect
                                className="ql-header"
                                defaultValue=""
                            >
                                <StyledNoteToolbarSelectOption value="1"></StyledNoteToolbarSelectOption>
                                <StyledNoteToolbarSelectOption value="2"></StyledNoteToolbarSelectOption>
                                <StyledNoteToolbarSelectOption value="3"></StyledNoteToolbarSelectOption>
                                <StyledNoteToolbarSelectOption value="4"></StyledNoteToolbarSelectOption>
                                <StyledNoteToolbarSelectOption value="5"></StyledNoteToolbarSelectOption>
                                <StyledNoteToolbarSelectOption value="6"></StyledNoteToolbarSelectOption>
                                <StyledNoteToolbarSelectOption value=""></StyledNoteToolbarSelectOption>
                            </StyledNoteToolbarSelect>
                        </StyledNoteToolbarItem>
                        <StyledNoteToolbarItem className="ql-formats">
                            <StyledNoteToolbarSelect className="ql-align">
                                <StyledNoteToolbarSelectOption value=""></StyledNoteToolbarSelectOption>
                                <StyledNoteToolbarSelectOption value="center"></StyledNoteToolbarSelectOption>
                                <StyledNoteToolbarSelectOption value="right"></StyledNoteToolbarSelectOption>
                                <StyledNoteToolbarSelectOption value="justify"></StyledNoteToolbarSelectOption>
                            </StyledNoteToolbarSelect>
                        </StyledNoteToolbarItem>
                        <StyledNoteToolbarItem className="ql-formats">
                            <StyledNoteToolbarButton className="ql-bold"></StyledNoteToolbarButton>
                            <StyledNoteToolbarButton className="ql-italic"></StyledNoteToolbarButton>
                            <StyledNoteToolbarButton className="ql-underline"></StyledNoteToolbarButton>
                        </StyledNoteToolbarItem>
                        <StyledNoteToolbarItem className="ql-formats">
                            <StyledNoteToolbarSelect className="ql-color">
                                {props.colors.map((color) => (
                                    <StyledNoteToolbarSelectOption
                                        key={color}
                                        value={color}
                                    ></StyledNoteToolbarSelectOption>
                                ))}
                            </StyledNoteToolbarSelect>
                            <StyledNoteToolbarSelect className="ql-background">
                                {props.colors.map((color) => (
                                    <StyledNoteToolbarSelectOption
                                        key={color}
                                        value={color}
                                    ></StyledNoteToolbarSelectOption>
                                ))}
                            </StyledNoteToolbarSelect>
                        </StyledNoteToolbarItem>
                        <StyledNoteToolbarItem className="ql-formats">
                            <StyledNoteToolbarButton
                                className="ql-list"
                                value="ordered"
                            ></StyledNoteToolbarButton>
                            <StyledNoteToolbarButton
                                className="ql-list"
                                value="bullet"
                            ></StyledNoteToolbarButton>
                        </StyledNoteToolbarItem>
                        {props.hasAddTimeline === true && (
                            <StyledNoteToolbarItem className="ql-formats">
                                <StyledNoteToolbarButton
                                    className="ql-addtimeline"
                                    data-time-progress={props.timeProgress}
                                    onClick={() => props.fnAddClickEvent()}
                                    ref={props.refButtonAddTimeline}
                                    title={localized["Label.AddTimeline"]}
                                >
                                    <i className="far fa-clock"></i>
                                </StyledNoteToolbarButton>
                            </StyledNoteToolbarItem>
                        )}
                    </StyledNoteToolbar>
                    {/* ReactQuill ノート本文 */}
                    <StyledNoteBody>
                        <ReactQuill
                            defaultValue={props.defaultValue}
                            modules={props.modules}
                            readOnly={
                                props.isActive !== undefined && !props.isActive
                            }
                            ref={props.refQuill}
                            theme="snow"
                        />
                    </StyledNoteBody>
                    {/* ナビゲーション */}
                    <StyledNoteNavigation>
                        {props.textNavigation !== "" && (
                            // ナビゲーションテキストがある場合は優先して出力
                            <StyledNoteNavigationText>
                                {props.textNavigation}
                            </StyledNoteNavigationText>
                        )}
                        {props.textNavigation === "" &&
                            props.updatetime !== "" && (
                                // ナビゲーションテキストが無く更新日時がある場合は出力
                                <StyledNoteNavigationHistory>
                                    <StyledNoteNavigationHistoryIcon>
                                        <i
                                            className="fa fa-history"
                                            key="icon-history"
                                        ></i>
                                    </StyledNoteNavigationHistoryIcon>
                                    <StyledNoteNavigationHistoryTime>
                                        {props.updatetime}
                                    </StyledNoteNavigationHistoryTime>
                                </StyledNoteNavigationHistory>
                            )}
                        <StyledNoteNavigationButtonlist>
                            {/* 削除ボタン */}
                            {props.hasButtonDelete === true && (
                                <StyledNoteNavigationButtonlistItem>
                                    <StyledNoteButton
                                        data-type="delete"
                                        disabled={
                                            props.isActive !== undefined &&
                                            !props.isActive
                                        }
                                        onClick={(e) =>
                                            props.fnOnClickDelete(e)
                                        }
                                    >
                                        <StyledNoteButtonIcon>
                                            <i className="fas fa-trash"></i>
                                        </StyledNoteButtonIcon>
                                        <StyledNoteButtonText>
                                            {localized["Label.Delete"]}
                                        </StyledNoteButtonText>
                                    </StyledNoteButton>
                                </StyledNoteNavigationButtonlistItem>
                            )}
                            {/* 保存ボタン */}
                            <StyledNoteNavigationButtonlistItem>
                                <StyledNoteButton
                                    data-type="save"
                                    disabled={
                                        props.isActive !== undefined &&
                                        !props.isActive
                                    }
                                    onClick={(e) => props.fnOnClickSave(e)}
                                >
                                    <StyledNoteButtonIcon>
                                        <i className="fas fa-save"></i>
                                    </StyledNoteButtonIcon>
                                    <StyledNoteButtonText>
                                        {localized["Label.Save"]}
                                    </StyledNoteButtonText>
                                </StyledNoteButton>
                            </StyledNoteNavigationButtonlistItem>
                        </StyledNoteNavigationButtonlist>
                    </StyledNoteNavigation>
                </StyledNote>
            )}
            <ModalNoteDelete
                isOpenModal={props.isOpenModalNoteDelete}
                noteId={props.noteId}
                setCurrentPage={props.setCurrentPage}
                setIsOpenDrawerNote={props.setIsOpenDrawerNote}
                setIsOpenModal={props.setIsOpenModalNoteDelete}
            />
        </>
    );
};
